<template>
    <div class="outer">
        <!-- 新建/编辑固定渠道弹窗（行政 31/48） -->
        <el-dialog width="40%" :title="channelDialogTitle" :close-on-click-modal="false"
            :visible="channelVisible" @close="closeChannelDialog">
            <el-form ref="channelForm" :model="channelForm" :rules="channelRules" label-width="110px">
                <el-form-item label="供应商名称" prop="supplierId" required>
                    <el-select filterable style="width: 100%" v-model="channelForm.supplierId" placeholder="请选择供应商">
                        <el-option v-for="item in supplierList" :key="item.id" :value="item.id" :label="item.supplierName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货物类别" prop="goodsClassCode" required>
                    <el-cascader style="width: 100%" v-model="channelForm.goodsClassCode"
                        :props="{ label: 'goodsClassName', value: 'goodsClassCode', emitPath: false, checkStrictly: true }"
                        :options="classOptions" placeholder="请选择货物类别">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input style="width: 100%" type="textarea" :rows="3" v-model="channelForm.remarks"
                        placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeChannelDialog">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitChannel">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 审批记录弹窗 -->
        <el-dialog width="50%" destroy-on-close title="审批记录" :close-on-click-modal="false"
            :visible="approvalRecordVisible" @close="approvalRecordVisible = false">
            <template v-if="stageList.length > 0">
                <el-timeline style="margin-top: 30px">
                    <el-timeline-item :timestamp="item.endTime" v-for="(item, i) in stageList"
                        :type="item.approvalResult === '1' ? 'success' : item.approvalResult === '2' ? 'danger' : ''"
                        :key="i">
                        {{ i + 1 }}.<template v-if="item.approvalResult">
                            【已审批-{{ item.approvalResultName }}】, 【操作人：{{ item.dealUserName }}】, 【意见/建议：{{ item.opinion }}】
                        </template>
                        <template v-else>
                            【待审批】 【操作人：{{ item.dealUserName }}】
                        </template>
                    </el-timeline-item>
                </el-timeline>
                <div style="position: absolute;bottom: 20px;right: 20px;">
                    当前审批人: {{ currentApprovalUser }}
                </div>
            </template>
            <el-empty v-else description="无需审批"></el-empty>
        </el-dialog>

        <!-- 财务审批固定渠道弹窗 -->
        <el-dialog width="45%" destroy-on-close title="审批固定渠道" :close-on-click-modal="false"
            :visible="approveVisible" @close="approveVisible = false">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="供应商名称">{{ approveForm.supplierName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="货物类别">{{ approveForm.goodsClassName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="创建人">{{ approveForm.createUserName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ approveForm.remarks || '--' }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="approvalChannel(2)">驳 回</el-button>
                <el-button type="primary" @click="approvalChannel(1)">通 过</el-button>
            </span>
        </el-dialog>

        <el-tabs v-model="activeName" type="card">
            <!-- 固定渠道列表（行政 31/48 创建管理） -->
            <el-tab-pane label="固定渠道列表" name="1" v-if="canManage">
                <div class="topSearch">
                    <el-form class="queryRow" inline :model="queryForm">
                        <el-form-item label="供应商名称" class="queryCol">
                            <el-select v-model="queryForm.supplierId" clearable @change="onSearch" @clear="onSearch">
                                <el-option v-for="item in supplierList" :key="item.id" :value="item.id"
                                    :label="item.supplierName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="渠道状态" class="queryCol">
                            <el-select v-model="queryForm.status" clearable placeholder="请选择" @change="onSearch" @clear="onSearch">
                                <el-option value="1" label="草稿"></el-option>
                                <el-option value="2" label="审批中"></el-option>
                                <el-option value="3" label="生效"></el-option>
                                <el-option value="4" label="已驳回"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="queryCol">
                            <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" icon="el-icon-plus" @click="openChannelDialog('add')">新建固定渠道</el-button>
                </div>

                <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
                    style="width: 100%;height: 68vh;overflow: auto;" :data="channelList">
                    <template slot="empty">
                        <el-empty :image-size="150"></el-empty>
                    </template>
                    <el-table-column align="center" label="渠道编号" prop="channelNo" width="180">
                    </el-table-column>
                    <el-table-column align="center" label="供应商名称" prop="supplierName">
                    </el-table-column>
                    <el-table-column align="center" label="货物类别" prop="goodsClassName">
                    </el-table-column>
                    <el-table-column align="center" label="创建人" prop="createUserName">
                    </el-table-column>
                    <el-table-column align="center" label="渠道状态" prop="status">
                        <template slot-scope="scope">
                            <el-tag :type="statusTagType(scope.row.status)">{{ statusName(scope.row.status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="备注" prop="remarks">
                    </el-table-column>
                    <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" width="300">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-document"
                                @click="openChannelDialog('detail', scope.row)">详情</el-button>
                            <el-button type="text" icon="el-icon-s-claim"
                                @click="openApprovalRecord(scope.row)">审批记录</el-button>
                            <el-button type="text" icon="el-icon-position" v-if="scope.row.status == 1"
                                @click="submitChannelApproval(scope.row)">提交审批</el-button>
                            <el-button type="text" icon="el-icon-edit"
                                v-if="scope.row.status == 1 || scope.row.status == 4"
                                @click="openChannelDialog('edit', scope.row)">修改</el-button>
                            <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                v-if="scope.row.status == 1 || scope.row.status == 4"
                                @click="deleteChannel(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pageination">
                    <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                        :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
                        :current-page="queryForm.page" background layout="sizes, prev, pager, next, jumper, ->, total">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <!-- 固定渠道审批（财务 27） -->
            <el-tab-pane label="固定渠道审批" name="2" v-if="canApprove">
                <div class="topSearch">
                    <el-form class="queryRow" inline :model="apprQueryForm">
                        <el-form-item label="本人是否审批" class="queryCol">
                            <el-select v-model="apprQueryForm.func" @change="onApprSearch">
                                <el-option :value="2" label="未审批"></el-option>
                                <el-option :value="1" label="已审批"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table v-loading="apprLoading" border class="table" :row-style="{ height: '50px' }"
                    style="width: 100%;height: 68vh;overflow: auto;" :data="apprList">
                    <template slot="empty">
                        <el-empty :image-size="150"></el-empty>
                    </template>
                    <el-table-column align="center" label="渠道编号" prop="channelNo" width="180">
                    </el-table-column>
                    <el-table-column align="center" label="供应商名称" prop="supplierName">
                    </el-table-column>
                    <el-table-column align="center" label="货物类别" prop="goodsClassName">
                    </el-table-column>
                    <el-table-column align="center" label="创建人" prop="createUserName">
                    </el-table-column>
                    <el-table-column align="center" label="渠道状态" prop="status">
                        <template slot-scope="scope">
                            <el-tag :type="statusTagType(scope.row.status)">{{ statusName(scope.row.status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
                    </el-table-column>
                    <el-table-column align="center" v-if="apprQueryForm.func === 1" label="审批意见" prop="opinion">
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-document"
                                @click="openApproveDialog(scope.row)">审批</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pageination">
                    <el-pagination @size-change="onApprSizeChange" @current-change="onApprCurrentChange"
                        :total="apprTotal" :page-size="apprQueryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
                        :current-page="apprQueryForm.page" background
                        layout="sizes, prev, pager, next, jumper, ->, total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { getSupplierList, getGoodsClassList } from '@/api/goods/goodsBusiness.js';
import { approvalStageList, applyApprovalReject } from '@/api/goods/buyForm.js';
import { getFixedChannelList, addFixedChannel, updateFixedChannel, submitFixedChannel, deleteFixedChannel, fixedChannelApprovedList } from '@/api/goods/fixedChannel.js';
import { canManageFixedChannel, canApproveFixedChannel } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            activeName: '1',
            canManage: canManageFixedChannel(), // 固定渠道管理（行政 48/31）
            canApprove: canApproveFixedChannel(), // 固定渠道审批（财务 27）
            loading: false,
            total: 0,
            channelList: [],
            queryForm: {
                supplierId: null,
                status: null,
                page: 1,
                limit: 10,
            },
            supplierList: [],
            classOptions: [],
            channelVisible: false,
            channelDialogType: '',
            channelDialogTitle: '',
            channelForm: {
                supplierId: '',
                goodsClassCode: '',
                remarks: '',
            },
            channelRules: {
                supplierId: [
                    { required: true, message: '请选择供应商' },
                ],
                goodsClassCode: [
                    { required: true, message: '请选择货物类别' },
                ],
            },
            btnLoading: false,
            stageList: [],
            approvalRecordVisible: false,
            approveVisible: false,
            approveForm: {},
            apprLoading: false,
            apprTotal: 0,
            apprList: [],
            apprQueryForm: {
                func: 2,
                page: 1,
                limit: 10,
            },
        }
    },
    computed: {
        currentApprovalUser() {
            return this.stageList.find(item => !item.approvalResult)?.dealUserName || '无';
        }
    },
    created() {
        this.activeName = this.canManage ? '1' : '2';
        this.getSupplierList();
        this.getGoodsClassList();
        if (this.canManage) this.getChannelList();
        if (this.canApprove) this.getApprList();
    },
    methods: {
        // 状态
        statusName(status) {
            switch (String(status)) {
                case '1': return '草稿';
                case '2': return '审批中';
                case '3': return '生效';
                case '4': return '已驳回';
                default: return '--';
            }
        },
        statusTagType(status) {
            switch (String(status)) {
                case '1': return 'info';
                case '2': return 'warning';
                case '3': return 'success';
                case '4': return 'danger';
                default: return '';
            }
        },
        // 列表
        getChannelList() {
            this.loading = true;
            getFixedChannelList(this.queryForm).then(res => {
                this.loading = false;
                if (res && res.code === 200) {
                    this.total = res.count;
                    this.channelList = res.data;
                } else {
                    this.channelList = [];
                    this.total = 0;
                }
            }).catch(() => {
                this.loading = false;
                this.channelList = [];
                this.total = 0;
            })
        },
        onSearch() {
            this.queryForm.page = 1;
            this.getChannelList();
        },
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getChannelList();
        },
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getChannelList();
        },
        // 弹窗
        openChannelDialog(type, row) {
            this.channelDialogType = type;
            if (type === 'add') {
                this.channelDialogTitle = '新建固定渠道';
                this.channelForm = { supplierId: '', goodsClassCode: '', remarks: '' };
            } else if (type === 'edit') {
                this.channelDialogTitle = '修改固定渠道';
                this.channelForm = { ...row };
            } else {
                this.channelDialogTitle = '固定渠道详情';
                this.channelForm = { ...row };
            }
            this.channelVisible = true;
        },
        closeChannelDialog() {
            this.channelForm = { supplierId: '', goodsClassCode: '', remarks: '' };
            this.$refs.channelForm && this.$refs.channelForm.resetFields();
            this.channelVisible = false;
        },
        submitChannel() {
            this.$refs.channelForm.validate((valid) => {
                if (!valid) return;
                this.btnLoading = true;
                const send = { ...this.channelForm };
                const api = this.channelDialogType === 'add' ? addFixedChannel(send) : updateFixedChannel(send);
                api.then(res => {
                    this.btnLoading = false;
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: this.channelDialogType === 'add' ? '新建成功' : '修改成功' });
                        this.channelVisible = false;
                        this.getChannelList();
                    }
                }).catch(() => {
                    this.btnLoading = false;
                    this.$message({ type: 'warning', message: '操作失败（固定渠道接口待后端联调）' });
                });
            });
        },
        // 提交审批（草稿 → 审批中）
        submitChannelApproval(row) {
            this.$confirm(`确定提交固定渠道「${row.supplierName} - ${row.goodsClassName}」审批吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                submitFixedChannel({ id: row.id, channelNo: row.channelNo }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '已提交审批' });
                        this.getChannelList();
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: '提交失败（固定渠道接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 删除
        deleteChannel(row) {
            this.$confirm('确定删除该固定渠道吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteFixedChannel({ id: row.id }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '删除成功' });
                        this.getChannelList();
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: '删除失败（固定渠道接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 审批记录
        openApprovalRecord(row) {
            approvalStageList({ applyCode: row.channelNo || row.id }).then(res => {
                if (res && res.code === 200) {
                    this.stageList = res.data;
                } else {
                    this.stageList = [];
                }
            }).catch(() => {
                this.stageList = [];
            });
            this.approvalRecordVisible = true;
        },
        // 审批列表（财务）
        getApprList() {
            this.apprLoading = true;
            fixedChannelApprovedList(this.apprQueryForm).then(res => {
                this.apprLoading = false;
                if (res && res.code === 200) {
                    this.apprTotal = res.count;
                    this.apprList = res.data;
                } else {
                    this.apprList = [];
                    this.apprTotal = 0;
                }
            }).catch(() => {
                this.apprLoading = false;
                this.apprList = [];
                this.apprTotal = 0;
            });
        },
        onApprSearch() {
            this.apprQueryForm.page = 1;
            this.getApprList();
        },
        onApprSizeChange(e) {
            this.apprQueryForm.page = 1;
            this.apprQueryForm.limit = e;
            this.getApprList();
        },
        onApprCurrentChange(e) {
            this.apprQueryForm.page = e;
            this.getApprList();
        },
        openApproveDialog(row) {
            this.approveForm = { ...row };
            this.approveVisible = true;
        },
        // 财务审批（approvalType 7 = 固定渠道审批，待后端确认）
        approvalChannel(approvalResult) {
            const title = approvalResult === 1 ? '审批通过' : '审批驳回';
            this.$prompt('请输入审批意见', title, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: approvalResult === 1 ? '同意' : '',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '审批意见不能为空!'
            }).then(({ value }) => {
                applyApprovalReject({
                    approvalType: 7,
                    applyCode: this.approveForm.channelNo || this.approveForm.id,
                    approvalResult,
                    opinion: value
                }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({ type: 'success', message: '操作成功' });
                        this.approveVisible = false;
                        this.apprQueryForm.func = 1;
                        this.getApprList();
                        if (this.canManage) this.getChannelList();
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: '审批失败（固定渠道审批接口待后端联调）' });
                });
            }).catch(() => { });
        },
        // 获取供应商列表（仅行政供应商，排除商务进销存供应商）
        getSupplierList() {
            getSupplierList({ page: 1, limit: 2000, category: '行政' }).then(res => {
                if (res && res.code === 200) {
                    this.supplierList = (res.data || []).filter(item => String(item.category || '行政') !== '商务');
                }
            });
        },
        getGoodsClassList() {
            getGoodsClassList({ classFlag: "2" }).then(res => {
                if (res && res.code === 200) {
                    this.classOptions = res.data;
                }
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.outer {
    height: 80vh;

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;
    }

    .table {
        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
